import { render, staticRenderFns } from "./jessibucaDemo.vue?vue&type=template&id=f98766dc&"
import script from "./jessibucaDemo.vue?vue&type=script&lang=js&"
export * from "./jessibucaDemo.vue?vue&type=script&lang=js&"
import style0 from "./jessibucaDemo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports